export default "__VITE_ASSET__5ab4b9d9__"